import moment from 'moment';
import CheckIcon from '@components/@core/CheckIcon';

const Accepted = ({ data }) => (
    <>
        <div className="d-flex ai-center">
            <CheckIcon className="color-basic" size={26} checked />
            <span className="dsl-b20 bold">Accepted</span>
        </div>
        <div className="d-flex ai-center mt-3 agreed">
            <span className="dsl-m12">Date</span>
            <span className="dsl-b14">{moment.utc(data?.time).local().format('MMM DD YYYY')}</span>
        </div>
        <div className="d-flex ai-center mt-3 agreed">
            <span className="dsl-m12">Time</span>
            <span className="dsl-b14">{moment.utc(data?.time).local().format('hh:mm A')}</span>
        </div>
        <div className="d-flex ai-center mt-3 agreed">
            <span className="dsl-m12">IP address</span>
            <span className="dsl-b14">{data?.ip}</span>
        </div>
    </>
);

export default Accepted;
